/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { injectable } from 'inversify';
import { MarriageCertificateListPageAgent, getAgent } from './agent';
import { logger as log } from '../../../common/logger';
const is = require('is_js');

const SERVICE_NAME = 'MarriageCertificateListPageService';

@injectable()
export class MarriageCertificateListPageService {
  private static instance: MarriageCertificateListPageService;
  public agent: MarriageCertificateListPageAgent;
  static displayName = 'MarriageCertificateListPageService';

  constructor(props: any = {}) {
    this.agent = getAgent();
  }
}
